exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.automation-create-component[data-v-ea101700] {\n  position: relative;\n}\n", ""]);

// exports
